import { Injectable } from '@angular/core';
import { CrudService } from './crud.service';
import type { Contract } from '../interfaces/contract';

@Injectable({
  providedIn: 'root'
})
export class ContractService extends CrudService<Contract> {
  constructor() {
    super('contracts');
  }
}
